import { EntityManager } from "typeorm";
import { Err, ErrorCode } from "./error";
import { Account, CompanyLifeCycleEvent, Company } from "./model";

export async function saveLifeCycleEvent(
    account: Account,
    event: CompanyLifeCycleEvent,
    company: Company,
    db: EntityManager
) {
    if (!account.admin) {
        throw new Err(
            ErrorCode.INSUFFICIENT_PERMISSIONS,
            "Sie haben keine ausreichenden Berechtigungen für diese Aktion!"
        );
    }

    event.createdBy = account.name;
    event.companyId = company.id;

    await db.save(event);
    company.lifeCycleEvents = sortLifeCycleEvents([...(company.lifeCycleEvents || []), event]);
}

export async function deleteLifecycleEvent(account: Account, id: number, company: Company, db: EntityManager) {
    if (!account.admin) {
        throw new Err(
            ErrorCode.INSUFFICIENT_PERMISSIONS,
            "Sie haben keine ausreichenden Berechtigungen für diese Aktion!"
        );
    }

    if (company.lifeCycleEvents.length === 1) {
        return;
    }

    const eventIndex = company.lifeCycleEvents.findIndex((e) => e.id === id);
    await db.delete(CompanyLifeCycleEvent, id);
    company.lifeCycleEvents.splice(eventIndex, 1);
}

export function sortLifeCycleEvents(events: CompanyLifeCycleEvent[]): CompanyLifeCycleEvent[] {
    return events.sort((a, b) => {
        if (a.date !== b.date) {
            return a.date < b.date ? -1 : 1;
        }

        return a.created.getTime() - b.created.getTime();
    });
}

// remove comments and employee names before giving data to customer
export function removeInternalData(events: CompanyLifeCycleEvent[]): CompanyLifeCycleEvent[] {
    return events.map(
        (e) =>
            new CompanyLifeCycleEvent({
                id: e.id,
                date: e.date,
                created: e.created,
                status: e.status,
            })
    );
}
